const reducer = state => ({
  ...state,
  serverError: null,
  waiting: false,
});

export default reducer;
